import type { TeamMember } from '../types';
import { h } from '../utils/dom';

export function renderAvatars(team: TeamMember[], container: HTMLElement): void {
  container.innerHTML = '';
  const visible = team.slice(0, 3);
  for (const member of visible) {
    const avatar = h('div', { class: 'att-avatar' });
    avatar.style.background = member.widgetColor ?? nameToColor(member.name);
    avatar.textContent = getInitials(member.name);
    container.appendChild(avatar);
  }
}

export function renderAgentAvatar(member: TeamMember | null, container: HTMLElement): void {
  container.innerHTML = '';
  const avatar = h('div', { class: 'att-avatar att-avatar--agent' });
  if (member) {
    avatar.style.background = member.widgetColor ?? nameToColor(member.name);
    avatar.textContent = getInitials(member.name);
  } else {
    avatar.style.background = '#6b7280';
    avatar.textContent = 'A';
  }
  container.appendChild(avatar);
}

export function getInitials(name: string): string {
  return name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
}

export function nameToColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return `hsl(${Math.abs(hash) % 360}, 65%, 55%)`;
}
